export const PAYMENT_ENCRYPTION_KEY = process.env.REACT_APP_PAYMENT_ENCRYPTION_KEY
export const PAYMENT_SECRET_KEY = process.env.REACT_APP_PAYMENT_SECRET_KEY

export const CART_URL_ENCRYPTION_KEY = process.env.REACT_APP_CART_URL_ENCRYPTION_KEY

export const PAYMENT_REDIRECT_KEY = process.env.REACT_APP_PAYMENT_REDIRECT_KEY
